'use client';

import { createContext } from 'react';

export type LabelContextValue = Record<string, string | undefined | null>;

export const LabelContext = createContext<LabelContextValue | null>(null);
